import React from "react";
import { Box, Grid, Paper, Stack, Typography, Chip } from "@mui/material";
import { ComputerOutlined, AutoAwesomeOutlined, ReceiptLongOutlined } from "@mui/icons-material";

const BackOfficeSection = () => {
  return (
    <Box component="section" id="backoffice" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <Paper
            elevation={10}
            sx={{
              borderRadius: 4,
              p: 3,
              bgcolor: "rgba(15,23,42,0.85)",
              border: "1px solid rgba(148,163,184,0.25)",
            }}
          >
            <Stack spacing={2}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <ComputerOutlined sx={{ color: "#fff" }} />
                <Typography variant="h6" sx={{ color: "#fff", fontWeight: 800 }}>
                  What BackOffice Connects To
                </Typography>
              </Stack>

              <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.75)" }}>
                BackOffice runs on (or connects to) the station backoffice PC to read fuel sales data.
                It can also read other store sales (snacks, convenience, etc.) — but fuel sales is the key
                for automated compliance.
              </Typography>

              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Chip label="Reads Fuel Sales" icon={<ReceiptLongOutlined />} sx={{ color: "#fff" }} />
                <Chip label="Auto-Reconciliation" icon={<AutoAwesomeOutlined />} sx={{ color: "#fff" }} />
              </Stack>
            </Stack>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 900, fontFamily: "Poppins, sans-serif" }}>
              BackOffice
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              <Chip
                label="Fully Automated Compliance"
                sx={{ bgcolor: "rgba(34,197,94,0.18)", color: "#fff", fontWeight: 900 }}
              />
              <Chip
                label="Fuel Sales Reconciliation"
                sx={{ bgcolor: "rgba(59,130,246,0.18)", color: "#fff", fontWeight: 900 }}
              />
              <Chip
                label="Pairs with ATG Pro"
                sx={{ bgcolor: "rgba(148,163,184,0.18)", color: "#fff", fontWeight: 900 }}
              />
            </Stack>

            <Typography variant="h3" sx={{ color: "rgba(226,232,240,0.8)", maxWidth: 560 }}>
              BackOffice is the missing link that makes compliance truly hands-off.
              It pulls fuel sales from your station’s backoffice system and combines it with ATG inventory,
              deliveries, and tank readings to produce <b>fully automated SIR reports</b>.
            </Typography>

            <Typography variant="h3" sx={{ color: "rgba(226,232,240,0.7)", maxWidth: 560 }}>
              Result: no monthly spreadsheets, no manual copy/paste, no guessing — reporting stays current automatically.
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BackOfficeSection;
